import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookedTrip, Flight, PassengerFlightInfo } from '@ibe/models';
import { BookingStep } from '@ibe/models/ui';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { takeWhile, map } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as _ from 'lodash';

import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as BookingStepActions from '@ibe/store/actions/booking-steps.actions';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import * as FlightResultActions from '@ibe/store/actions/flight-result.actions';

import { INDRALoginModalComponent } from '@ibe.components/shared/login-modal/login-modal.indra.component';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';

import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { BookingService } from '@ibe.services/booking.tap.service';

import { 
	TRIP_TYPE_ROUND_TRIP_CODE, 
	TRIP_TYPE_ONE_WAY_CODE, 
	TRIP_TYPE_MULTICITY_CODE, 
	EQUIPMENT_CODE_BUS, 
	TTT_STATUS_ACTIVE, 
	DISCOUNT_TYPE_VOUCHER,
	DISCOUNT_TYPE_PROMOCODE,
	DISCOUNT_AMOUNT_TYPE_FIXED,
	DISCOUNT_AMOUNT_TYPE_PERCENTAGE,
	DISCOUNT_APPLY_TO_TOTAL,
	DISCOUNT_STATUS_ACTIVE,
	DISCOUNT_STATUS_INACTIVE
} from '@ibe.config';



@Component({
	selector: 'app-booking-price-breakdown',
	templateUrl: './booking-price-breakdown.indra.component.html',
	styleUrls: ['./booking-price-breakdown.component.scss']
})
export class INDRABookingPriceBreakdownComponent implements OnInit, OnDestroy {
	private isAlive = true;
	
	VOUCHER_DISCOUNT = DISCOUNT_TYPE_VOUCHER;
	PROMOCODE_DISCOUNT = DISCOUNT_TYPE_PROMOCODE;
	FIXED_TYPE_DISCOUNT = DISCOUNT_AMOUNT_TYPE_FIXED;
	PERCENTAGE_TYPE_DISCOUNT = DISCOUNT_AMOUNT_TYPE_PERCENTAGE;

	// Data
	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booked_trip;

	stopOvers$: Observable<Array<any>> = this.store.select(fromStore.getMiniIBEStopovers);
	stopOvers: Array<any> = [];

	bookingSteps$: Observable<BookingStep[]> = this.store.select(fromStore.getSelectedBookingSteps);
	bookingSteps: BookingStep[];

	userInfo$: Observable<Object> = this.store.select(fromStore.getUserInfo);
	userInfo: any = false;
	isLoggedIn: boolean;

	bookedTripDiscounts$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripDiscounts);
	bookedTripDiscounts: Array<any> = [];

	confirmModalCallback$: Observable<string> = this.store.select(fromStore.getConfirmModalConfirm);
	confirmModalCallback = '';

	promocoCodesAndVoucher$: Observable<Array<any>> = this.store.select(fromStore.getSelectedPromoVouchers);
	promocoCodesAndVoucher: Array<any> = [];

	weakFlightsDiscount$: Observable<number> = this.store.select(fromStore.getWeakFlightAmt);
	weakFlightsDiscount: any;

	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlights: boolean;

	//flightWithMiles$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterFlightWithMiles);
	//flightWithMiles: boolean;

	payingWithMiles: boolean = true;
	milesInFlightDiscount$: Observable<any> = this.store.select(fromStore.getMilesInFlightDiscount);
	milesInFlightDiscount: any;
	milesSpent$: Observable<number> = this.store.select(fromStore.getTotalMilesToSpend);
	milesSpent: number;
	discountedBookingCost$: Observable<number> = this.store.select(fromStore.getDiscountedBookingCost);
	discountedBookingCost: number = 0;
	originalBookingCost$: Observable<number> = this.store.select(fromStore.getOriginalBookingCost);
	originalBookingCost: number = 0;

	noFlights: Array<any> = [];

	airlineLogo;
	currency: string;
	userData: any;
	adminFee = 0;
	
	isTTTFlow: boolean = false; // time to think purchase (to save booking prices)
	isNormalBookingOrActiveTTT: boolean = false;
	
	flightInformation$: Observable<any> = this.store.select(fromStore.getFlightInformation);
    flightInformation: any;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private store: Store<fromStore.State>,
		private modalService: ModalService,
		private currencyService: INDRACurrencyService,
		private bookingSearchService: INDRABookingSearchService,
        private bookingService: BookingService,
		private flightPriceService: INDRAFlightPriceService,
		protected ibeAdminService: INDRAIbeAdminService,
		private bfmStorage: INDRABFMDataStorageService,
		private storage: INDRAStorageService
	) {
		this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
			
		this.bookingSteps$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((value) => {
				if (value) {
					this.bookingSteps = value;
				}
			});

		this.bookAwardFlights$
		.pipe(takeWhile(() => this.isAlive))
		.subscribe(value => {
			this.bookAwardFlights = value;
		});

		this.stopOvers$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.stopOvers = value;
			});

		this.bookedTrip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.booked_trip = value;
					this.INDRA_generateFlights(this.booked_trip);
					this.isNormalBookingOrActiveTTT = this.INDRA_isNormalBookingOrActiveTTT(this.booked_trip);
				}
			});
			
		this.promocoCodesAndVoucher$
			.pipe(
				takeWhile(() => this.isAlive),
				map(value => value && value.filter(discount => discount.status === DISCOUNT_STATUS_ACTIVE))
			)
			.subscribe(discounts => {
				if (discounts && discounts.length != 0) {
					this.promocoCodesAndVoucher = Object.assign([], discounts);
				} else {
					this.promocoCodesAndVoucher = [];
				}
			});

		this.confirmModalCallback$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((value) => {
				if (value) {
					this.confirmModalCallback = value;
				}
			});

		this.bookedTripDiscounts$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(discounts => {
				this.bookedTripDiscounts = Object.assign([], discounts);
			});


		this.userInfo$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.userInfo = value;
					this.isLoggedIn = true;
				}
        else {
					this.isLoggedIn = false;
        }
			});

		this.weakFlightsDiscount$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value != null) {
					this.weakFlightsDiscount = value;
				}
			});

		/*
		this.flightWithMiles$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.flightWithMiles = value;
			});
		*/	

		this.milesInFlightDiscount$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.milesInFlightDiscount = value;
				}
			});

		this.milesSpent$
			.pipe(takeWhile(() => this.isAlive))
				.subscribe(value => {
				this.milesSpent = value;
				this.payingWithMiles = this.milesSpent > 0 ? true : false;
			});

		this.discountedBookingCost$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.discountedBookingCost = value;
			});

		this.originalBookingCost$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.originalBookingCost = value;
			});
		
		this.flightInformation$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					if (value && value.flight.flight) {
						if (this.booked_trip.flights.length === 0) {
							this.booked_trip = {
								...this.booked_trip,
								flights: []
							};

							this.booked_trip.flights.push(value.flight.flight);
							this.INDRA_generateFlights(this.booked_trip);
						} else if (this.booked_trip.booking_type === TRIP_TYPE_ROUND_TRIP_CODE) {
							const isInbound = value.flight.flight.bound === 'inbound';
							if (isInbound && this.booked_trip.flights.length === 1) {;
								this.booked_trip = {
									...this.booked_trip,
									flights: [...this.booked_trip.flights, ...value.flight.flight]
								};
							}
							this.INDRA_generateFlights(this.booked_trip);
						}

						this.isNormalBookingOrActiveTTT = this.INDRA_isNormalBookingOrActiveTTT(this.booked_trip);
					}
				}
			});

	}

	ngOnInit() {
		this.isTTTFlow = this.router.url.includes('/time-to-think')? true : false;

		if (this.router.url.includes('/review-your-trip') || this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think') || this.router.url.includes('/extras-to-your-trip')) {
			const pnrDetails = this.bfmStorage.originalPNRDetailsResponse;
			this.adminFee = pnrDetails && pnrDetails.data.fare && pnrDetails.data.fare.originalFlightPrice
				&& pnrDetails.data.fare.originalFlightPrice.totalPrice && pnrDetails.data.fare.originalFlightPrice.totalPrice.adminFee
				&& pnrDetails.data.fare.originalFlightPrice.totalPrice.adminFee.amount ?
				pnrDetails.data.fare.originalFlightPrice.totalPrice.adminFee.amount : 0;
		}
	}

	ngOnDestroy() {
		this.isAlive = false;
		this.booked_trip = null;
	}

	INDRA_generateFlights(booked_trip) {
		this.noFlights = [];
		if (booked_trip.flights.length) {
			if (booked_trip.booking_type === TRIP_TYPE_ONE_WAY_CODE ||
				booked_trip.booking_type === TRIP_TYPE_MULTICITY_CODE) {
				if (booked_trip.flights.length === 0) {
					this.noFlights.push(0);
				}
			} else if (booked_trip.booking_type === TRIP_TYPE_ROUND_TRIP_CODE) {
				const diff = 2 - booked_trip.flights.length;
				for (let i = 0; i < diff; i++) {
					this.noFlights.push(i);
				}
			}
		} else {
			if (booked_trip.booking_type === TRIP_TYPE_MULTICITY_CODE ||
				booked_trip.booking_type === TRIP_TYPE_ONE_WAY_CODE ||
				this.stopOvers && this.stopOvers.length > 0) {
				this.noFlights.push(0);
			} else {
				this.noFlights.push(0);
				this.noFlights.push(1);
			}
		}
	}

	INDRA_printFlightDate(flight): string {
		if (flight) {
			const date = moment(new Date(flight.listSegment[0].departureDate.slice(0, -5)));
			const dateTime = date.format('D - kk:mm');
			let day = date.format('dddd').toLowerCase();
			let month = date.format('MMMM').toLowerCase();

			day = this.INDRA_getTranslation('dates.text.' + day);
			month = this.INDRA_getTranslation('dates.text.' + month);

			return `${day.substring(0, 3)}, ${month.substring(0, 3)} ${dateTime}`; 
		}
	}

	INDRA_handleFareAndTaxes() {
		
		let fareTaxesParams = {
			isDupe: false,
			isTTTBookingForCompletion: false
		};
		
		this.sidebarService.openSidebar(['fare-and-taxes', fareTaxesParams]);
	}

	INDRA_handleVoucherOrPromocode() {
		this.sidebarService.openSidebar(['voucher-or-promocode']);
	}

	/**
	 * Handles a back event from the context menu
	 */
	INDRA_handleBack() {
		
		this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('priceBreakdown.text.backToSelection')));
		this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('priceBreakdown.text.ifYouContinue')));
		this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('priceBreakdown.text.dontLeavePage')));
		this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('priceBreakdown.text.chooseFlightsAgain')));
		this.modalService.assignComponent(INDRAConfirmModalComponent);
		this.modalService.open();

		this.modalService.isOpen
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((value) => {
				if (!value) {
					if (this.confirmModalCallback === 'ok') {
						this.store.dispatch(new ConfirmModalActions.ResetAction());
						if (this.booked_trip.stopover) {
							this.router.navigate(['/booking/flights-stopover']);
						} else {
							if (this.booked_trip.booking_type === TRIP_TYPE_MULTICITY_CODE) {
								this.router.navigate(['/booking/flights-multicity']);
							} else {
								this.router.navigate(['/booking/flights']);
							}
						}

						this.closeSidebar();
						this.INDRA_clearBookedTrip();
					}
				}
			});
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
	}

	/**
	 * Clear selected dates
	 */
	INDRA_clearBookedTrip() {
		const auxArray: Array<BookingStep> = [];
		this.bookingSteps.forEach(step => { auxArray.push(Object.assign(new BookingStep(null, null), step, { flight_selected: false })); });

		const booked_trip = Object.assign(new BookedTrip([], this.booked_trip.pnr, this.booked_trip.booking_type), this.booked_trip);
		booked_trip.emptyFlights();

		this.store.dispatch(new BookedTripActions.PutBookedTripAction(booked_trip));
		this.store.dispatch(new BookingStepActions.PutStepsAction(auxArray));
		this.store.dispatch(new BookingStepActions.PutCurrentStepAction(0));

	}

	/** Handles close action intention **/
	INDRA_handleClose() {
		this.closeSidebar();
	}

	showLoginModal() {
		this.modalService.assignComponent(INDRALoginModalComponent);
		this.modalService.open();
	}

	INDRA_handleSignUp() {
		this.sidebarService.openSidebar(['sign-up']);
	}

	INDRA_printAirlineLogo(flights) {
		if (flights) {
			const busSegmentCount = flights.listSegment.filter(segment => segment.equipment === EQUIPMENT_CODE_BUS).length;
			if (busSegmentCount > 0) {
				this.airlineLogo = 'Bus';
				return 'icons.svg#plane_related--plane_and_bus';
			} else {
				if (flights.listSegment.length > 1) {
					const ALL_SAME_AIRLINE = flights.listSegment.every((val, i, arr) => val.operationCarrier === arr[0].operationCarrier);

					if (ALL_SAME_AIRLINE) {
						this.airlineLogo = flights.listSegment[0].operationCarrier;
					} else {
						this.airlineLogo = 'Multiple';
					}
				} else {
					this.airlineLogo = flights.listSegment[0].operationCarrier;
				}
				return this.bookingSearchService.INDRA_buildAirlineLogoName(this.airlineLogo);
			}
		} else {
			this.airlineLogo = 'not_found';
			return this.bookingSearchService.INDRA_buildAirlineLogoName(this.airlineLogo);
		}
	}

	INDRA_hasBookedTrip() {
		if (this.noFlights.length == 0 && this.booked_trip.flights.length) {
			return true;
		}
	}

	INDRA_getPrice(priceOf) {
		switch (priceOf) {
			case 'flights':
				return this.INDRA_getFlightTotalCost();
			case 'discounts':
				return this.flightPriceService.INDRA_getDiscountsTotal(
					this.promocoCodesAndVoucher, this.bookedTripDiscounts, this.weakFlightsDiscount, 
					this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights, this.currency);
			case 'otherCharges':
				return this.flightPriceService.INDRA_getOtherChargesTotal();
			case 'finalAmountWithDiscountsAndNoMilesGo':
				return this.flightPriceService.INDRA_getBookingTotalCost(
					this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights, true,
					this.promocoCodesAndVoucher, this.bookedTripDiscounts, this.weakFlightsDiscount, [], [], 0);
			default:
				return '';
		}
	}

	INDRA_getFlightPrice(flight) {
		return this.flightPriceService.INDRA_getFlightTotalCost(flight, this.booked_trip.booking_type, this.bookAwardFlights);
	}

	INDRA_isUserLoggedIn() {
		this.userData = this.storage.get('userData');
		if (this.userData != null) {
			return true;
		}
		return false;
	}


	INDRA_getFlightTotalCost() {
		if (this.milesInFlightDiscount && this.milesInFlightDiscount.miles && this.milesInFlightDiscount.cash) {
			const flightTotalPrice = this.flightPriceService.computeSelectedFlightsTotalPrice(this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights);
			if(this.isLoggedIn) {
				return this.INDRA_formatMiles(this.milesInFlightDiscount.miles) + ' + ' + this.INDRA_formatCash(flightTotalPrice - this.milesInFlightDiscount.cash);
			}
			else {
				return this.INDRA_formatCash(flightTotalPrice);
			}
		} else {
			return this.flightPriceService.INDRA_getSelectedFlightsTotalCost(
				this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights);
		}
	}

	INDRA_printOriginalPrice() {
		// return this.INDRA_formatCash(this.originalBookingCost);

		return this.flightPriceService.INDRA_getBookingTotalCost(
			this.booked_trip.flights,
			this.booked_trip.booking_type,
			this.bookAwardFlights,
			true,
			[],
			[],
			[],
			[],
			[],
			0
		)
	}

	INDRA_printMiles() {
		return this.INDRA_formatMiles(this.milesSpent);
	}


	INDRA_printFinalPrice() {
		if (this.milesInFlightDiscount && this.milesInFlightDiscount.miles && this.milesInFlightDiscount.cash) { 
			const flightTotalPrice = this.flightPriceService.computeSelectedFlightsTotalPrice(this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights);

			if(this.isLoggedIn) {
				return this.INDRA_formatCash(flightTotalPrice - this.milesInFlightDiscount.cash);
			}
			else {
				return this.INDRA_formatCash(flightTotalPrice);
			}
		}
		if (this.payingWithMiles) {
			return this.INDRA_formatCash(this.discountedBookingCost);
		} else {
			return this.INDRA_printOriginalPrice();
		}
	}

	INDRA_formatMiles(value) {
		return value.toFixed(0) + ' M';
	}

	INDRA_formatCash(value, currency?) {
		const currencyToDisplay = currency ? currency : this.currency;
		return value.toFixed(2) + ' ' + currencyToDisplay;
	}
	
	INDRA_isNormalBookingOrActiveTTT(bookedTrip) {
		return (!bookedTrip || !bookedTrip.time_to_think || !bookedTrip.time_to_think.status || bookedTrip.time_to_think.status === TTT_STATUS_ACTIVE);
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
	
	INDRA_handleDetailsClick(flight) {
		this.store.dispatch(new FlightResultActions.PutSelectedFlightAction(Object.assign(new Flight(null, null, null), flight)));	
		this.sidebarService.openSidebar(['flight-details', { flight: flight.listSegment[0].flightNumber, mode: 'search' }]);
	}

}
